module.exports = __webpack_public_path__ + "static/media/disabledFullIcon.b1ade211.svg";